export default {
  isNumber: function (evt) {
    evt = evt ? evt : window.event
    var charCode = evt.which ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault()
    } else {
      return true
    }
  },
  isNumberOrHifen: function (evt) {
    evt = evt ? evt : window.event
    var charCode = evt.which ? evt.which : evt.keyCode
    if (charCode != 45 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault()
    } else {
      return true
    }
  },
  isDecimalNumber: function (evt) {
    evt = evt ? evt : window.event
    var charCode = evt.which ? evt.which : evt.keyCode
    if (charCode != 190 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true
    } else {
      return false
    }
  }
}
